import * as React from 'react';
import { Spinner } from 'react-bootstrap';

export default class LogisticaDeLiquidacion extends React.Component {

    render = () => {

        const logistica = this.props.logistica;

        return (

            this.props.isLoading ?

            <div className="d-flex justify-content-center">
                <Spinner animation="border" variant="secondary" size="lg-centrado" role="status">
                    <span className="sr-only">Loading...</span>
                </Spinner>
            </div>

            :

            logistica.length > 0 ?
        
            <div className="row justify-content-center align-items-center p-10">

                <h5 className="col-auto">Fee Logístico</h5>

                <div className="list-group-item col-12 animated fadeIn">
                    <div className="table-responsive card">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th scope="col">Id Venta</th>
                                    <th scope="col">Id Cotización</th>
                                    <th scope="col">Peso Hasta</th>
                                    <th scope="col">Peso Aforado</th>
                                    <th scope="col">Código Postal</th>
                                    <th scope="col">Importe</th>

                                </tr>
                            </thead>
                            <tbody>
                            {
                                logistica.map((item, i) => {
                                    return (
                                        <tr key={i} className="hover-background-color">
                                            <td><small><span>{item.idVenta}</span></small></td>
                                            <td><small><span>{item.idCotizacion}</span></small></td>
                                            <td><small><span>{item.pesoHasta}</span></small></td>
                                            <td><small><span>{item.pesoAforado ?? '-'}</span></small></td>
                                            <td><small><span>{item.codigoPostal}</span></small></td>
                                            <td><small><span>${item.importe}</span></small></td>

                                        </tr>
                                    )
                                })
                            }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            :

            <div className="card">
                <div className="card-body">
                    <div className="row justify-content-center align-items-center p-10">
                        No hay información de logistica para esta liquidación
                    </div>
                </div>
            </div>
        )
    }
}